// extracted by mini-css-extract-plugin
export default {"icon":"classes_icon__a+wuA"};